module.exports = __webpack_public_path__ + "img/bowling-ball.7c4e2f6d.svg";